// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsent_banner__KSKFl","text":"CookieConsent_text__aU5K+","link":"CookieConsent_link__lxJE5","actions":"CookieConsent_actions__DvCW5"};